import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Content } from './style';

//libs
import Translation from 'libs/Translation';

// Component
import Text from 'components/common/Text';

const ReadMore = ({ text, tag }) => {
    const router = useRouter();
    const [showMore, setShowMore] = useState(false);

    useEffect(() => {
        setShowMore(false)
    }, [router])

    const handleُToggleShowMore = () => {
        setShowMore(!showMore);
    }

    return (
            <Content>
                <div className="row-flex">
                    <Text
                        className="text"
                        tag={tag}
                    >
                        {showMore 
                        ? text 
                        :
                        <>
                            {text.substring(0, 150)}... {' '}
                            <span 
                                className="button"
                                onClick={handleُToggleShowMore}
                            >
                                {Translation.t('label.more')}
                            </span>
                        </>
                        }
                    </Text>
                 </div>
            </Content>
    )
}

export default ReadMore;